<template>
    <div class="address-card" :class="{ 'address-card--selected': selected }">
        <div class="address-card__header">
            <strong class="address-card__title">{{ title }}</strong>
            <CieloInputRadio
                :id="'address-radio-' + _uid"
                :name="'address'"
                :checked="selected"
                :aria-label="$ml.get('ariaLabelSelectAddress')"
                @change="$emit('select')"
            />
        </div>

        <div class="address-card__subtitle">
            {{ subtitle }}
        </div>

        <button
            class="address-card__edit"
            @click="$emit('edit')"
            :aria-label="$ml ? $ml.with(0, title).get('ariaLabelEditSection') : 'Editar endereço'"
        >
            {{ $ml ? $ml.get('edit') : 'Editar' }}
        </button>

        <slot />
    </div>
</template>

<script>
import CieloInputRadio from '@/components/ClickToPay/template/CieloInputRadio.vue';


export default {
	name: 'AddressCard',
	components: {
		CieloInputRadio
	},
	props: {
		title: {
			type: String,
			required: true,
		},
		subtitle: {
			type: String,
			required: true,
		},
		selected: {
			type: Boolean,
			default: false,
		},
	},
};

</script>

<style scoped lang="scss">

	.address-card {
		border: 1.5px solid #DBE0E5;
		border-radius: 16px;
		padding: 16px;
		margin-bottom: 20px;
		background-color: #FFFFFF;
		position: relative;
		transition: border-color 0.2s;

		&__header {
			display: flex;
			justify-content: space-between;
			align-items: flex-start;
			margin-bottom: 6px;
		}

		&__title {
			font-weight: 600;
			font-size: 16px;
			color: #2F363E;
			margin-right: 8px;
		}

		&__subtitle {
			font-weight: 500;
			color: #5C6A7B;
			font-size: 14px;
			padding-bottom: 12px;
			margin-bottom: 12px;
			border-bottom: 2px solid #DBE0E5;
		}

		&__edit {
			background: transparent;
			color: #0774E7;
			border: none;
			cursor: pointer;
			font-size: 14px;
			padding: 0;
			font-weight: 600;

			&:hover {
			text-decoration: underline;
			}
  		}

	}

</style>
